module.exports = __webpack_public_path__ + "static/media/image_45.c0abaf4e.png";